import script from "./CheckoutRightSidebarBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutRightSidebarBase.vue?vue&type=script&setup=true&lang=ts"

import "./CheckoutRightSidebarBase.vue?vue&type=style&index=0&id=755f5072&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-755f5072"]])

export default __exports__